export default {
  labels: {
    open: 'Afișează produse',
    collapse: 'Ascunde produse',
    in_stock: 'În stoc',
    out_of_stock: 'Stoc epuizat',
  },
  list: {
    name: 'Produs din meniu',
    price: 'Preț',
    is_available: 'ÎN STOC/STOC EPUIZAT',
  },
};
